import type { UserPreferencesNotificationsSwitchProps } from "./user-preferences-notifications-switch.type";

import { useUserPreferencesNotificationsContext } from "../user-preferences-notifications.context";

export const useUserPreferencesNotificationsSwitch = ({
  channel,
  notificationKey,
}: UserPreferencesNotificationsSwitchProps) => {
  const { savedSettings, unsavedSettings, defaultSettings, onSettingsChange } =
    useUserPreferencesNotificationsContext();

  const savedValue = savedSettings?.[notificationKey]?.[channel];
  const unsavedValue = unsavedSettings?.[notificationKey]?.[channel];
  const defaultValue = defaultSettings?.[notificationKey]?.[channel];

  const isChecked = unsavedValue ?? defaultValue;
  const isUnsaved = unsavedValue !== savedValue;

  const handleChange = (checked: boolean) => {
    onSettingsChange?.({ [notificationKey]: { [channel]: checked } });
  };

  return {
    handleChange,
    isChecked,
    isUnsaved,
  };
};
